import { AddOnsTemplate } from '@/components/add-ons/template';
import { GalleriesItem } from '@/components/galleries/item';
import { GalleriesList } from '@/components/galleries/list';
import { ComponentsHead } from '@/components/head';
import { StaticImage } from 'gatsby-plugin-image';
import { FC } from 'react';
import { SwiperSlide } from 'swiper/react';

export const FANTASY_ISLAND_TITLE = 'Fantasy Island';

export const Head = () => {
  return (
    <ComponentsHead
      title="Private Charter to Fantasy Island | TBBA Hidden Gem"
      description="Escape to Fantasy Island, a peaceful hideaway just minutes from Tampa. Our private charters bring you to this laid-back sandbar for sun, swimming, and serenity."
      keywords="Fantasy Island, Sandbar, Private Charter, Hidden Gem"
    />
  );
};

const Page: FC = () => {
  return (
    <AddOnsTemplate
      title="Fantasy Island Boat Charter – A Hidden Gem Near Tampa"
      subtitle={FANTASY_ISLAND_TITLE}
    >
      <GalleriesList>
        <SwiperSlide>
          <GalleriesItem>
            <StaticImage
              alt={`${FANTASY_ISLAND_TITLE} header`}
              src="../../images/destinations/fantasy-island/0.jpg"
            />
          </GalleriesItem>
        </SwiperSlide>
        <SwiperSlide>
          <GalleriesItem>
            <StaticImage
              alt={`${FANTASY_ISLAND_TITLE} slide 1`}
              src="../../images/destinations/fantasy-island/1.jpg"
            />
          </GalleriesItem>
        </SwiperSlide>
      </GalleriesList>
    </AddOnsTemplate>
  );
};

export default Page;
